/* A table's mark: the Data Table's blue sheet, People a grey person. The rail, the table's
   title, the schema's cards and the phone's chips all draw it. */
import React from "react";

/** The table's mark: the Data Table's blue sheet; People a grey person. */
export default function TableTile({ system = false, size = 18 }: { system?: boolean; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" aria-hidden="true">
      <rect width="18" height="18" rx="5" className={system ? "fill-[var(--text-tertiary)]" : "fill-[var(--dt-accent)]"} />
      {system ? (
        <>
          <circle cx="9" cy="7" r="2.2" stroke="var(--dt-on-accent)" strokeWidth="1.4" fill="none" />
          <path d="M5.2 13.2a3.8 3.8 0 0 1 7.6 0" stroke="var(--dt-on-accent)" strokeWidth="1.4" strokeLinecap="round" fill="none" />
        </>
      ) : (
        <path d="M5 6.5h8M5 9h8M5 11.5h5" stroke="var(--dt-on-accent)" strokeWidth="1.4" strokeLinecap="round" />
      )}
    </svg>
  );
}
